import { GridApi } from 'ag-grid-community';

export const fillGridBlankSpace = (api: GridApi) => {
  const columns = api.getAllDisplayedColumns();
  if (!columns || columns.length === 0) return;

  const gridBodyElement = document.querySelector('.ag-body-viewport');
  if (!gridBodyElement) return;

  const availableWidth = gridBodyElement.clientWidth;
  const usedWidth = columns.reduce((sum, col) => sum + (col.getActualWidth() || 0), 0);
  const remainingGridSpace = availableWidth - usedWidth;
  const lastColumn = columns[columns.length - 1];
  const minColumnWidth = lastColumn.getMinWidth() || 100;

  // Prevent from setting column width below its minWidth
  const newWidth: number =
    lastColumn.getActualWidth() + remainingGridSpace <= minColumnWidth
      ? minColumnWidth
      : lastColumn.getActualWidth() + remainingGridSpace;

  // Assign remaining blank space to last column width
  api.setColumnWidths([{ key: lastColumn.getId(), newWidth }]);
};
